import {React,useEffect,useReducer, useState} from 'react'
import { Link,useParams,Route } from 'react-router-dom'
import { Moviedis } from '../Component/Fetcher'
import Header from '../Component/Header';
import Favourite from '../Component/Favourite'


const initaistate = {
    loading:true,
    data: {},
    error:''

}

const reducer=(state,action)=>{

switch(action.type){
    case 'success':
   
        return{
            loading:false,
            data:action.payload,
            error: '',
            
        }
        case 'failed':
            return{
                loading:true,
                data:'',
                error : action.errormessage,
                
            }
}
}

const Moviediscription = () => {
    const [movienamediscription , dispatch]=useReducer(reducer,initaistate)
    const {movieid}= useParams()
   useEffect(()=>{
    Moviedis({movieid,dispatch})
   },[movieid])



   const render = ()=>{
  return  movienamediscription.data.map((data)=>{
    return  <div key={data.id} id='videodis-container'>
    <h2 >{data.title} thriller</h2>
      <video controls src={`/asset/${data.video}`}/>
      <p>Short discription</p>
      <h4>{data.description}</h4>
      <p> Link to Watch the Movie </p>
      <a href={data.movielink} target="_blank">
          Click here to watch movie
        </a>
     </div>
    })
   }

  
  return (
    <div>
        <Header/>
      
        {movienamediscription.loading ? 'loading' : render ()}
        {movienamediscription.error ? movienamediscription.error:null}
        <Favourite/>
    </div>
  )
}

export default Moviediscription